import { buildURL, buildPixelDensitySrcSet } from "imgix-url-builder";
import { imageThumbnail } from "./isFilled.js";
const DEFAULT_PIXEL_DENSITIES = [1, 2, 3];
const asImagePixelDensitySrcSet = (field, config = {}) => {
  if (field && imageThumbnail(field)) {
    const { pixelDensities = DEFAULT_PIXEL_DENSITIES, ...imgixParams } = config;
    return {
      src: buildURL(field.url, imgixParams),
      srcset: buildPixelDensitySrcSet(field.url, {
        ...imgixParams,
        pixelDensities
      })
    };
  } else {
    return null;
  }
};
export {
  asImagePixelDensitySrcSet
};
//# sourceMappingURL=asImagePixelDensitySrcSet.js.map
